import role from './role'
import realm from './realm'
import permission from './permission'
import limit from './limit'
import licensePermission from './license-permission'
import limitLicense from './limit-license'

export default {
  name: 'Security',
  path: 'security',
  meta: {
    label: 'security',
    auth: 'security'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [role, realm, permission, limit, licensePermission, limitLicense]
}
